import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/searchEmpty.png';
const _withScopeId = n => (_pushScopeId("data-v-64bed3f2"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "search-empty",
  src: _imports_0,
  alt: "search-empty"
}, null, -1));
const _hoisted_2 = {
  key: 0,
  class: "t-empty__title"
};
const _hoisted_3 = {
  key: 1,
  class: "t-empty__desc"
};
const _hoisted_4 = {
  class: "hint"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['t-empty', {
      't-empty-absolute': _ctx.isAbsolute
    }, _ctx.propsClass])
  }, [_renderSlot(_ctx.$slots, "default", {}, undefined, true), _hoisted_1, _ctx.title ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1)) : _createCommentVNode("", true), _ctx.desc ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.desc), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_4, [_createTextVNode(" 请重新搜索或者返回"), _createElementVNode("span", {
    class: "back_news",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.backNews && _ctx.backNews(...args))
  }, "出海资讯"), _createTextVNode("页面 ")])], 2);
}